import React from 'react';
import {Drawer, DrawerContentProps} from '@mantine/core';

export const EtroDrawerContent: React.FC<DrawerContentProps> = props => {
  return <Drawer.Content {...props} />;
};
